import { useState } from 'react';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { useBottomBannerSlot } from '../../hooks/useBottomBannerSlot';

export function InstallBanner() {
  const { isInstallable, isIOSInstallable, install } = usePWAInstall();
  const { showBanner: cookieBannerVisible } = useCookieConsent();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('pwa-banner-dismissed') === 'true'
  );

  // Não mostrar enquanto o banner de cookies estiver visível.
  const wantsShow = !(dismissed || (!isInstallable && !isIOSInstallable) || cookieBannerVisible);
  // Cede o slot do rodapé ao UpdatePrompt (prioridade maior) — nunca os dois juntos.
  const ownsSlot = useBottomBannerSlot(wantsShow, 'pwa-install', 1);

  if (!wantsShow || !ownsSlot) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa-banner-dismissed', 'true');
  };

  const handleInstall = async () => {
    if (isInstallable) {
      await install();
    }
  };

  return (
    <div className="fixed bottom-24 sm:bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[480px] bg-[#2D4A3E] rounded-[14px] px-5 py-4 flex items-center gap-3.5 shadow-2xl z-[9999]">
      {/* Ícone */}
      <div className="w-11 h-11 bg-[#C9A96E] rounded-xl flex items-center justify-center flex-shrink-0">
        <svg width="22" height="22" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 4C20 4 12 8 12 16C12 20.4183 15.5817 24 20 24C24.4183 24 28 20.4183 28 16C28 8 20 4 20 4Z" fill="#2D4A3E"/>
          <path d="M20 24C20 24 16 26 16 30C16 32.2091 17.7909 34 20 34C22.2091 34 24 32.2091 24 30C24 26 20 24 20 24Z" fill="#2D4A3E"/>
          <path d="M20 14V36" stroke="#2D4A3E" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Texto */}
      <div className="flex-1 min-w-0">
        <p className="text-white text-[13px] font-semibold leading-tight mb-0.5">
          Instalar Essência
        </p>
        <p className="text-white/65 text-[11px] leading-relaxed">
          {isIOSInstallable
            ? 'Toque em Compartilhar → "Adicionar à Tela de Início"'
            : 'Acesse sua clínica direto da tela inicial'
          }
        </p>
      </div>

      {/* Botões */}
      <div className="flex items-center gap-2 flex-shrink-0">
        {isInstallable && (
          <button
            onClick={handleInstall}
            className="bg-[#C9A96E] text-[#2D4A3E] text-xs font-bold px-3.5 py-2 rounded-lg cursor-pointer"
          >
            Instalar
          </button>
        )}
        <button
          onClick={handleDismiss}
          className="text-white/50 text-xs border border-white/20 px-2.5 py-2 rounded-lg cursor-pointer"
        >
          Agora não
        </button>
      </div>
    </div>
  );
}
